<div class="mainWraps">
    <div class="bgImageWrap">
        <img src="../../../assets/images/servicesBg.png">
    </div>
    <div class="bgMobileImageWrap">
        <img src="../../../assets/images/ServicesMobile.png">
    </div>

    <div class="overLay">
        <div class="textWraps">
            <div class="titleWraps">
              Services
            </div>
            <div class="subTitleWrap">
               Our featured services
            </div>
            <div class="knowMoreWrap">
               <!--  <div class="buttonWrap">
                    <button>
                        KNOW MORE
                    </button>
                </div> -->
            </div>
        </div>
    </div>
</div>


<div class="service-provider">
    <div class="mainWrap">
        <div class="headerSection">
        <!--     <div class="titleWrap">
                Service We Provide
            </div> -->
            <div class="descWrap">
                We help Internet-based businesses and product companies design and develop cloud-native web and mobile solutions. We drive digital transformation for businesses by helping them provide a rich, seamless experience to their customers across digital channels resulting in higher engagement, efficiency, and profitability.
            </div>
        </div>
        <div class="bodySection">
            <div class="rowWrap" *ngFor = "let i of services">
                <div class="card">
                    <div class="imageWrap">
                        <img src="{{i.imageUrl}}">
                    </div>
                    <div class="textWrap">
                        <div class="titleRowWrap">
                           {{i.title}}
                        </div>
                        <div class="descRowWrap">
                           {{i.desc}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>